/* eslint-disable guard-for-in */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core';
import userServices from '../../../../redux/services/userServices';
import ProfessionalNeeds from './ProfessionalNeeds';
import InterestsNeeds from './InterestsNeeds';
import WorkNeeds from './WorkNeeds';

const NeedsSelection = ({
  group,
  vocPro,
  setVocPro,
  vocInterests,
  setVocInterests,
  vocWork,
  setVocWork,
}) => {
  const [globalNeeds, setGlobalNeeds] = useState({
    logistics: 0,
    sales: 0,
    marketing: 0,
    hr: 0,
    finance: 0,
    legal: 0,
    engineering: 0,
    production: 0,
    quality: 0,
    it: 0,
    otherPro: 0,
    news: 0,
    environment: 0,
    economy: 0,
    politics: 0,
    art: 0,
    sport: 0,
    travelling: 0,
    education: 0,
    leisure: 0,
    otherVoc: 0,
    meetings: 0,
    presentations: 0,
    negotiations: 0,
    emails: 0,
    telephoning: 0,
    otherWorksRelated: 0,
  });

  useEffect(async () => {
    if (group && group._id) {
      const res = await userServices.getStudentByGroup(group._id);
      if (res !== undefined && res !== null && res.length > 0) {
        // setStudentsList(res);
        let globalNeedsObj = { ...globalNeeds };
        res.forEach((student) => {
          if (student.needs) {
            for (const need in student.needs) {
              for (const item in globalNeedsObj) {
                if (item === need && student.needs[need]) {
                  globalNeedsObj = { ...globalNeedsObj, [item]: globalNeedsObj[item] += 1 };
                }
              }
            }
          }
        });
        setGlobalNeeds(globalNeedsObj);
      }
    }
  }, [group]);

  return (
    <Card style={{ marginBottom: '20px', marginTop: '20px' }}>
      <CardContent>
        <Grid container>
          <Grid item xs={4}>
            <Typography variant="body1" style={{ marginBottom: '20px', marginTop: '20px' }}>Professional/technical vocabulary</Typography>
            <ProfessionalNeeds vocPro={vocPro} setVocPro={setVocPro} globalNeeds={globalNeeds} />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" style={{ marginBottom: '20px', marginTop: '20px' }}>General vocabulary</Typography>
            <InterestsNeeds vocInterests={vocInterests} setVocInterests={setVocInterests} globalNeeds={globalNeeds} />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" style={{ marginBottom: '20px', marginTop: '20px' }}>Professional skills</Typography>
            <WorkNeeds vocWork={vocWork} setVocWork={setVocWork} globalNeeds={globalNeeds} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default NeedsSelection;
